import type { WebStorageStateStore } from 'oidc-client-ts';

/**
 * OneLogin OIDC configuration for the SMA Tickets Portal.
 *
 * Required env vars:
 *   VITE_ONELOGIN_CLIENT_ID  — Client ID from OneLogin OIDC app
 *   VITE_ONELOGIN_ISSUER     — e.g. https://starmicronics.onelogin.com/oidc/2
 */

const clientId = import.meta.env.VITE_ONELOGIN_CLIENT_ID ?? '';
const issuer = import.meta.env.VITE_ONELOGIN_ISSUER ?? '';

// Derive the redirect URI from the current origin
const redirectUri = `${window.location.origin}/callback`;
const postLogoutRedirectUri = window.location.origin;

export const oidcConfig = {
  authority: issuer,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: 'code',
  scope: 'openid profile email',
  // Route the token exchange through our server-side proxy so the
  // client_secret never ships to the browser.
  metadataSeed: {
    token_endpoint: `${window.location.origin}/api/token`,
  },
  // Use sessionStorage so auth doesn't persist across browser sessions
  userStore: undefined as unknown as WebStorageStateStore,
  automaticSilentRenew: true,
};

/**
 * Check whether OIDC is configured. If env vars are missing,
 * we skip auth entirely so the app still works in development.
 */
export function isOidcConfigured(): boolean {
  return Boolean(clientId && issuer);
}
